import {dataTestId} from '@hconnect/uikit'
import {Collapse, Stack, Box} from '@mui/material'
import React, {useState} from 'react'

import {AssetCapacity} from '../../interfaces'

import {AssetCapacityHeader} from './AssetCapacityHeader'
import {AssetCapacityTable} from './AssetCapacityTable'

interface AssetCapacitySectionProps {
  plantCode: string
  assetId: number
  assetCapacity: AssetCapacity
}

export const AssetCapacitySection: React.FC<AssetCapacitySectionProps> = ({
  plantCode,
  assetCapacity,
  assetId
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true)

  return (
    <Stack
      sx={{
        '&:not(:last-child)': {
          borderBottom: '1px solid',
          borderColor: ({palette}) => palette.divider
        }
      }}
      {...dataTestId('asset_capacity_section')}
    >
      <Box sx={{my: 2}}>
        <AssetCapacityHeader
          plantCode={plantCode}
          key={assetId}
          assetCapacity={assetCapacity}
          assetId={Number(assetId)}
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
        />
      </Box>
      <Collapse in={!isCollapsed}>
        <AssetCapacityTable assetCapacity={assetCapacity} />
      </Collapse>
    </Stack>
  )
}
